import Constants from '@/Constants';
import { FileUploadData, useFileUpload } from '@/hooks/upload/FileUpload';
import { ApplicationState } from '@/store';
import React, { SyntheticEvent, useRef } from 'react';
import { useSelector } from 'react-redux';
import { TypeAccepted } from '..';
import ProgressUpload from '../Progress';

interface LessonThumbProps {
    typeAccepted: TypeAccepted;
    disabled?: boolean;
    onStart?: () => void;
    onComplete?: (response: FileUploadData) => void;
    onRemove?: () => void;
    onCancel?: () => void;
}

const LessonThumbUpload: React.FC<LessonThumbProps> = ({
    typeAccepted,
    disabled = false,
    onStart,
    onComplete,
    onRemove,
    onCancel,
}: LessonThumbProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const { acceptConfiguration, uploadProcess, selectFileHandler, cancelHandler } = useFileUpload({
        typeAccepted,
        shortLabel: true,
        inputRef,
    });

    const disabledClass: string = disabled ? 'disabled' : '';

    const { accept, acceptLabel } = acceptConfiguration;
    const { progress, uploading } = uploadProcess;

    return (
        <label className={`upload-link ${disabledClass}`} htmlFor="file">
            <i className="material-icons-outlined">{Constants.icons.CLOUD_UPLOAD}</i>
            <input
                accept={accept}
                disabled={disabled}
                id="file"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => selectFileHandler(e, onStart, onComplete)}
                ref={inputRef}
                style={{ display: 'none' }}
                type="file"
            />

            {uploading ? (
                <ProgressUpload mode="THIN" onCancelHandler={(e: SyntheticEvent) => cancelHandler(e, onCancel, onRemove)} progress={progress} />
            ) : (
                <span>
                    {strings.HEADER}
                    <br />
                    {acceptLabel}
                </span>
            )}
        </label>
    );
};

export default LessonThumbUpload;
